import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, setPropTypes, withHandlers } from 'recompose';
import Pagination from '@material-ui/lab/Pagination';
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@material-ui/core';
import { PaginationItem } from '@material-ui/lab';
import { sendLogin } from '../../auth/Auth';

const propTypes = {
  classes: PropTypes.object.isRequired
};

const styles = {
  root: {
    display: 'flex'
  },
  textRange: {
    textAlign: 'left',
    marginRight: 23
  },
  pagination: {
    fontSize: 12,
    display: 'flex',
    alignItems: 'center',
    marginTop: 20,
    marginBottom: 20
  },
  nextPageButton: {
    borderRadius: 4,
    width: 44,
    minWidth: 44,
    height: 18,
    marginLeft: 10,
    backgroundColor: '#ffffff',
    border: '1px #CCCCCC solid',
    fontSize: 10
  },
  prevPageButton: {
    borderRadius: 4,
    width: 44,
    minWidth: 44,
    height: 18,
    marginRight: 10,
    backgroundColor: '#ffffff',
    border: '1px #CCCCCC solid',
    fontSize: 10
  },
  paginationItem: {
    minWidth: 18,
    width: 18,
    height: 18,
    fontSize: 12,
    backgroundColor: '#ffffff',
    '&.Mui-selected': {
      borderColor: '#2196F3',
      color: '#ffffff',
      backgroundColor: '#2196F3',
      '&:hover': {
        borderColor: '#2196F3',
        color: '#ffffff',
        backgroundColor: '#2196F3'
      }
    }
  },
  labelInput: {
    fontSize: 12,
    color: '#222222',
    marginLeft: 23
  },
  formControl: {
    fontSize: 12,
    marginLeft: 7
  },
  rowsPerPage: {
    fontSize: 12,
    color: '#000000'
  },
  rowsPerPageItem: {
    fontSize: 12,
    fontWeight: 500
  },
  paddingLeft8: {
    paddingLeft: 8,
    fontSize: '0.75rem',
    color: 'rgba(0, 0, 0, 0.54)',
    '&:before': {
      border: 'none'
    },
    '&:hover, &:focus': {
      backgroundColor: 'transparent',
      '&:not(.Mui-disabled)': {
        '&:before': {
          border: 'none'
        }
      }
    },
    '&:after': {
      display: 'none'
    }
  }
};

const enhance = compose(
  connect(),
  setPropTypes(propTypes),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    totalCount,
    count,
    handleChangePage,
    // sortType,
    limit,
    setLimit,
    selectedPage,
    handleChangeRowsPerPage,
    hideRowsPerPage
  }) => {
    const handleChangeLimit = event => {
      setLimit(event.target.value);
      handleChangePage(null, 1, event.target.value);
      if (handleChangeRowsPerPage)
        handleChangeRowsPerPage(event, event.target.value);
    };
    return (
      <div className={classes.pagination}>
        {totalCount && totalCount !== 0 ? (
          <div className={classes.textRange}>
            {`全${totalCount}件中${limit * (selectedPage - 1) + 1}~${
              limit * selectedPage < totalCount
                ? limit * selectedPage
                : totalCount
            }件を表示`}
          </div>
        ) : null}
        {selectedPage !== 1 && (
          <Button
            className={classes.prevPageButton}
            onClick={() => handleChangePage(null, selectedPage - 1, limit)}
          >
            前へ
          </Button>
        )}
        <Pagination
          variant="outlined"
          count={count}
          page={selectedPage}
          onChange={handleChangePage}
          hidePrevButton
          hideNextButton
          showLastButton={false}
          renderItem={item => (
            <PaginationItem {...item} className={classes.paginationItem} />
          )}
        />
        {selectedPage < count && (
          <Button
            className={classes.nextPageButton}
            onClick={() => handleChangePage(null, selectedPage + 1, limit)}
          >
            次へ
          </Button>
        )}
        {!hideRowsPerPage && (
          <>
            <InputLabel id="rowsPerPageLabel" className={classes.labelInput}>
              {`Rows per page: `}
            </InputLabel>
            <FormControl className={classes.formControl}>
              <Select
                labelId="rowsPerPageLabel"
                id="rowsPerPage"
                value={limit}
                onChange={handleChangeLimit}
                inputProps={{ className: classes.rowsPerPage }}
                className={classes.paddingLeft8}
              >
                <MenuItem
                  value={5}
                  data-limit-value={5}
                  className={classes.rowsPerPageItem}
                >
                  5
                </MenuItem>
                <MenuItem
                  value={20}
                  data-limit-value={20}
                  className={classes.rowsPerPageItem}
                >
                  20
                </MenuItem>
                <MenuItem
                  value={100}
                  data-limit-value={100}
                  className={classes.rowsPerPageItem}
                >
                  100
                </MenuItem>
              </Select>
            </FormControl>
          </>
        )}
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
